import { createTheme } from '@mui/material/styles';

// Cores personalizadas By Lust Lingerie
const theme = createTheme({
  palette: {
    primary: {
      main: '#eac0b7', // Cor base/cor oficial da logo
      light: '#f5d8d1',
      dark: '#d9a89f',
      contrastText: '#212121',
    },
    secondary: {
      main: '#cfa1d3', // Roxo suave
      light: '#e1c5e4',
      dark: '#b681ba',
      contrastText: '#212121',
    },
    info: {
      main: '#cfa1d3', // Usar secondary como info
      light: '#e1c5e4',
      dark: '#b681ba',
      contrastText: '#212121',
    },
    success: {
      main: '#8cbaa0', // Verde suave da nova paleta
      light: '#a8c9b5',
      dark: '#649077',
      contrastText: '#ffffff',
    },
    warning: {
      main: '#e6e76b', // Usar highlight como warning
      light: '#f0f084',
      dark: '#d1d15e',
      contrastText: '#212121',
    },
    error: {
      main: '#dbacbb', // Usar tertiary como error
      light: '#e8c8d3',
      dark: '#c2909f',
      contrastText: '#212121',
    },
    background: {
      default: '#fdf8f7',
      paper: '#ffffff',
    },
    text: {
      primary: '#4a4a4a',
      secondary: '#757575',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '48px',
      fontWeight: 300,
      letterSpacing: '-1.5px',
    },
    h2: {
      fontSize: '36px',
      fontWeight: 300,
      letterSpacing: '-0.5px',
    },
    h3: {
      fontSize: '24px',
      fontWeight: 300,
      letterSpacing: 'normal',
    },
    h4: {
      fontSize: '20px',
      fontWeight: 300,
      letterSpacing: 'normal',
    },
    h5: {
      fontSize: '16px',
      fontWeight: 400,
      letterSpacing: 'normal',
    },
    h6: {
      fontSize: '14px',
      fontWeight: 500,
      letterSpacing: '0.0075em',
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 1px 0 rgba(60,64,67,.08), 0 1px 3px 1px rgba(60,64,67,.16)',
          borderRadius: '8px',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '6px',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px 1px rgba(0,0,0,0.03)',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRight: 'none',
          boxShadow: '0 1px 3px 1px rgba(0,0,0,0.03)',
        },
      },
    },
  },
  shape: {
    borderRadius: 8,
  },
});

export default theme;
